import React from "react";

// MATERIAL-UI
import { Grid } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

interface LoadingProps {
  size?: any;
  color?: any;
}
const Preloader = (props: LoadingProps) => {
  return (
    <Grid
      id="preloader"
      container
      justifyContent="center"
      alignItems="center"
      style={{ height: "100%", overflow: "hidden", width: "fit-content" }}>
      <CircularProgress
        size={props.size ? props.size : undefined}
        sx={{ color: props.color ? props.color : undefined }}
      />
    </Grid>
  );
};

export default Preloader;
